import { cva } from 'class-variance-authority';
export const imageCircleStyling = cva('shrink-0 rounded-pill flex items-center justify-center pointer-events-none', {
    variants: {
        size: {
            sm: 'size-6 text-xs',
            md: 'size-7 text-sm',
            lg: 'size-8 text-base',
            xl: 'size-12 text-lg',
            '2xl': 'size-14 text-xl',
        },
        outline: {
            white: 'outline outline-4 outline-white',
            neutral: 'outline outline-4 outline-surface-muted',
            none: '',
        },
    },
    defaultVariants: {
        size: 'md',
        outline: 'none',
    },
});
